




















































































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AccountModule from '@/store/modules/Account';
import GeneralModule from '@/store/modules/General';
import AuthModule from '@/store/modules/Auth';
import CreateAccountData from '@/data/CreateAccount';
import jwt_decode from 'jwt-decode';

@Component
export default class AddSubAccountView extends Vue {
  AccountInstance = getModule(AccountModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  mainKey = 0;

  UserData = CreateAccountData.initialUserData();

  async onSubmit() {
    this.GeneralInstance.toggleLoading(true);
    const expToken: any = jwt_decode(this.AuthInstance.token);
    this.UserData.type = 'SEAMLESS';
    this.UserData.currency = expToken.currency || 'THB';
    this.UserData.role = this.AuthInstance.user.role === 'COMPANY' ? 'SUBCOMPANY' : 'SUBAGENT';
    const res = await this.AccountInstance.CreateAccount(this.UserData);
    if (res.status.code === 0) {
      this.UserData = CreateAccountData.initialUserData();
      this.mainKey += 1;
    }
    this.GeneralInstance.toggleLoading(false);
    this.GeneralInstance.ShowAlert({
      isAlert: true,
      alertMsg: res.status.message,
      alertColor: res.status.code === 0 ? 'success' : 'danger',
    });
  }
}
